module.exports = __webpack_public_path__ + "static/media/imagen_harinadetrigo.8313ad9c.png";